import React, { FC, createRef, useEffect, useMemo, useState } from "react";
import NewsletterModal from "components/NewsletterModal";
import { Button } from "@pepdirect/ui/button";
import st from "./index.module.scss";
import cx from "classnames";
import { useRouter } from "next/router";
import { useOnScreen } from "@pepdirect/helpers/useOnScreen";
import {
  generateHashedId,
  logInternalPromotionSelect,
  logInternalPromotionView,
} from "@pepdirect/helpers/analyticsLogger";

export const FocusPageHeroBanner: FC = () => {
  const router = useRouter();
  const ref = createRef<HTMLDivElement>();
  const isVisible = useOnScreen(ref);

  const [newsletterModalOpen, setNewsletterModalOpen] = useState<boolean>(true);
  const [isEventTriggered, setIsEventTriggered] = useState<boolean>(false);

  const promotionEventParams = useMemo(() => {
    const promotionName = "new focus launch";
    const promotionId = generateHashedId(promotionName);

    return {
      creativeName: "focus landing|hero|focus|01-2024",
      promotionName,
      promotionId,
      creativeSlot: "focus landing|hero|new launch|top|1",
    };
  }, []);

  useEffect(() => {
    if (isVisible && !isEventTriggered) {
      setIsEventTriggered(true);
      logInternalPromotionView("", promotionEventParams);
    }
  }, [isEventTriggered, isVisible, promotionEventParams]);

  return (
    <>
      <div className={st.container} ref={ref}>
        <div className={st["overlay-shelf"]} />
        <div className={st["inner-container"]}>
          <div className={st.textButtonWrapper}>
            <div className={st.text}>
              <h3 className={cx(st.heading, st.headingSmall)}>
                ENERGY & MENTAL BOOST* WITH LION’S MANE
              </h3>
              <h2 className={cx(st.heading, st.headingLarge)}>
                STAY IN THE MOMENT WITH ROCKSTAR ENERGY
              </h2>
              <p className={st.disclaimer}>
                *at least 75mg of caffeine has been shown to help improve
                attention
              </p>
            </div>
            <Button
              onClick={() => {
                logInternalPromotionSelect("", promotionEventParams);
                router.push({
                  pathname: "/shop-all",
                  hash: "products",
                  query: {
                    canSize: "All",
                    nutrition: "All",
                    subline: "Focus",
                    unAvailableProducts: "show",
                  },
                });
              }}
              className={st.button}
            >
              Shop Now
            </Button>
          </div>
          <div className={st.rightSide}>
            <div className={st.cans} />
            <div className={st.bar} />
          </div>
        </div>
      </div>
      <NewsletterModal
        isOpen={newsletterModalOpen}
        close={() => setNewsletterModalOpen(false)}
      />
    </>
  );
};
